<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil">
            <a-card >
                <a-layout>
                    <a-layout-sider style="background:#fff">
                        <a-menu
                        :default-selected-keys="['1']"
                        mode="inline"
                        >
                            <a-menu-item key="1">
                                <router-link  to="/home/account/base">
                                基本设置
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="2">
                                <router-link  to="/home/account/security">
                                安全设置
                                </router-link>
                            </a-menu-item>
                        </a-menu>
                    </a-layout-sider>

                    <a-layout-content :style="{margin:'0',paddingLeft: '24px', overflow: 'initial',background:'#fff !important' }">
                        <router-view/>
                    </a-layout-content>

                </a-layout>
            </a-card>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: '账号信息'},
            ],
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/index.vue